// src/features/landing/infrastructure/rbBridgeConsultApiRepository.js
// RB Bridge 상담 신청 (매수자 · 매도자 · 파트너스) → recruit-api M&A 고객(mna_client) 접수.
// 채용관 회원 데이터와 분리된 별도 도메인. 계약 정본: claude-hub
// projects/risingbrokers-api/claude/2610_mna_client/2610_mna_client.md
//
// 배포 순서 주의 (2026-10-03): isAvailable=true라 이 화면은 실제로 POST /api/mna/clients를 호출한다.
// recruit-api(엔드포인트 + mna_client DDL)가 먼저 배포된 뒤에 website를 배포해야 한다.
// 백엔드보다 먼저 나가면 신청이 모두 실패한다 — 그 경우 isAvailable을 false로 되돌리면
// API를 호출하지 않고 "온라인 접수 준비 중"(카카오톡·전화 안내) 화면으로 돌아간다.

const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

const NETWORK_ERROR_MESSAGE = '네트워크 연결이 원활하지 않아 신청을 보내지 못했습니다. 잠시 후 다시 시도해 주세요.';
const DEFAULT_ERROR_MESSAGE = '상담 신청에 실패했습니다. 잠시 후 다시 시도해 주세요.';

/**
 * POST /api/mna/clients (인증 불필요)
 * @param {Object} data
 * @param {'BUYER'|'SELLER'|'PARTNER'} data.clientType 매수자 / 매도자 / 파트너스
 * @param {string} data.name 이름(실명이 아니어도 됨, ≤50)
 * @param {string} data.phone 연락처 숫자만 (예: 01012345678) — 호출부가 하이픈 제거 후 전달
 * @param {string} data.email 이메일 (≤100)
 * @param {boolean} data.privacyAgreed 개인정보 수집·이용 동의 (true만 허용)
 * @param {string} [data.utmSource]
 * @param {string} [data.utmMedium]
 * @param {string} [data.utmCampaign]
 * @returns {Promise<Object>} 201 { id, createdAt }
 * @throws {Error} 400/500은 서버 message(한국어 문장)를 그대로, 네트워크 오류는 error.isNetworkError=true
 */
async function createClient(data) {
    let response;
    try {
        response = await fetch(`${API_BASE_URL}/api/mna/clients`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
    } catch {
        const error = new Error(NETWORK_ERROR_MESSAGE);
        error.isNetworkError = true;
        throw error;
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const error = new Error(errorData.message || DEFAULT_ERROR_MESSAGE);
        error.status = response.status;
        throw error;
    }

    return response.json().catch(() => ({}));
}

export const rbBridgeConsultRepository = {
    // true: 실제 접수. recruit-api 배포 후에만 website를 배포할 것 (위 배포 순서 주의 참고)
    isAvailable: true,
    createClient,
};
